















































































































































import { computed, defineComponent, reactive } from '@vue/composition-api'
import { ReceiptSupplier, receiptSuppliers } from '@/types/receipt'
import { Methods } from 'api/questionnaire-answer'
import { downloadAnswersCsvPath } from '@/api/questionnaire'
import { QuestionnaireEntity } from '../../../../api/@types'
import moment from 'moment'

type Props = {
  isFixedStatus: boolean
  questionnaireId: number | null
  checkerCheckStatus: NonNullable<Methods['get']['query']>['checkerCheckStatus']
  adminCheckStatus: NonNullable<Methods['get']['query']>['adminCheckStatus']
  enableDownload: boolean
  questionnaires: QuestionnaireEntity[]
}

export default defineComponent({
  name: 'SearchInput',
  props: {
    isFixedStatus: {
      type: Boolean,
      default: true,
    },
    questionnaireId: {
      type: Number,
      default: null,
    },
    checkerCheckStatus: {
      type: String,
      default: null,
    },
    adminCheckStatus: {
      type: String,
      default: null,
    },
    enableDownload: {
      type: Boolean,
      default: false,
    },
    questionnaires: {
      type: Array,
      default: () => [],
    },
  },
  setup(props: Props, context) {
    const state = reactive<{
      id: number | null
      questionnaireId: number | null
      checkerCheckStatus:
        | NonNullable<Methods['get']['query']>['checkerCheckStatus']
        | null
      adminCheckStatus:
        | NonNullable<Methods['get']['query']>['adminCheckStatus']
        | null
      supplier: ReceiptSupplier | null
      answeredAtStart: string | null
      answeredAtEnd: string | null
      name: string | null
      nameAdmin: string | null
    }>({
      id: null,
      questionnaireId: props.questionnaireId ?? null,
      checkerCheckStatus: props.checkerCheckStatus,
      adminCheckStatus: props.adminCheckStatus,
      supplier: null,
      answeredAtStart: null,
      answeredAtEnd: null,
      name: null,
      nameAdmin: null,
    })

    const search = () => {
      const query = Object.entries(state)
        .filter(([_key, value]) => value !== null && value !== '')
        .reduce((prev, [key, value]) => {
          prev[key] = ['answeredAtStart', 'answeredAtEnd'].includes(key)
            ? moment(value).toDate()
            : value
          return prev
        }, {} as any)
      context.emit('on-search', query)
    }

    const reset = () => {
      state.id = null
      state.questionnaireId = null
      state.checkerCheckStatus = props.checkerCheckStatus
      state.adminCheckStatus = props.adminCheckStatus
      state.supplier = null
      state.answeredAtStart = null
      state.answeredAtEnd = null
      state.name = null
      state.nameAdmin = null

      context.emit('on-reset')
    }

    const downloadUrl = computed<string>(() => {
      if (state.questionnaireId) {
        return downloadAnswersCsvPath(state.questionnaireId)
      }
      return ''
    })

    const checkStatus = [
      {
        text: '未処理',
        value: 'non',
      },
      { text: 'OK', value: 'ok' },
      { text: 'NG', value: 'ng' },
    ]

    const flags = reactive({
      answeredAtStartMenu: false,
      answeredAtEndMenu: false,
    })

    const questionnaireWithIds = props.questionnaires.map(q => ({
      id: q.id,
      name: `${q.id}: ${q.name}`,
    }))

    return {
      state,
      flags,
      receiptSuppliers,
      checkStatus,
      props,
      downloadUrl,
      search,
      reset,
      questionnaireWithIds,
    }
  },
})
